var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 286.9 234.5",
    style: {
      enableBackground: "new 0 0 286.9 234.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;fill:url(#SVGID_1_);}\r\n\t.st1{display:none;fill:#022A4F;}\r\n\t.st2{display:none;fill:#F7931E;}\r\n")), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 1429.1455,
    cy: -310.93,
    r: 140.86,
    gradientTransform: "matrix(0.44 0 0 -0.5 -471.14 -106.26)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCE0F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C3DCF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#A9D1ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#80BFE5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#47A7DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#1793D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#1E9CD7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#2EA2DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#0A7FC4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#0075BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#E1902C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    style: {
      stopColor: "#F7931E"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.5,0c-27.1,0-52.5,14.8-68.5,39.5h23c12.4-12.8,28.6-20,45.4-20c37.3,0,67.6,34.3,67.6,76.4 c0,0.9,0,1.8,0,2.7h17.2c0-0.9,0-1.8,0-2.7C235.1,43,197.1,0,150.5,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.3,184.8h109.3c3,7,9.4,11.8,16.7,11.8c10.3,0,18.6-9.4,18.6-21.1s-8.3-21.1-18.6-21.1 c-7.3,0-13.7,4.8-16.7,11.8H59.3c-23.3,0-42.3-21.4-42.3-47.9c-0.1-12.4,4.3-24.4,12.4-33.9c7.7-8.7,18.2-14,29.9-14h56.8 c3,7,9.4,11.8,16.7,11.8c10.3,0,18.6-9.4,18.6-21.1s-8.3-21.1-18.6-21.1c-7.3,0-13.7,4.8-16.7,11.8H58.7c-16.2,0-30.9,7.4-41.5,19.5 S0,100,0,118.3c0,36.7,26.3,66.5,58.7,66.5L64.3,184.8z M190.3,167.1c4.1,0,7.4,3.8,7.4,8.4s-3.3,8.4-7.4,8.4s-7.4-3.8-7.4-8.4 S186.1,167.1,190.3,167.1L190.3,167.1z M132.9,52.8c4.1,0,7.4,3.8,7.4,8.4s-3.3,8.4-7.4,8.4c-4.1,0-7.4-3.8-7.4-8.4 S128.8,52.8,132.9,52.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M272.3,126.8c-9.1-10.2-21.5-16.6-35.3-16.6H86.7c-3.3-5.9-9.1-9.7-15.7-9.7c-10.3,0-18.6,9.4-18.6,21.1 s8.3,21.1,18.6,21.1c7.5,0,14-5.1,16.9-12.4h150.3c17.9,0,32.3,16.4,32.3,36.6c0.1,9.5-3.3,18.7-9.5,25.9 c-5.7,6.7-14,10.7-22.9,10.8H65.9c-3.1-6.6-9.3-11.1-16.4-11.1c-10.3,0-18.6,9.4-18.6,21.1s8.3,21,18.6,21c7,0,13.2-4.4,16.3-11h171 c27.6,0,50-25.4,50-56.7C287.1,152.2,281.9,137.9,272.3,126.8z M71,129.9c-4.1,0-7.4-3.8-7.4-8.4s3.3-8.4,7.4-8.4s7.4,3.8,7.4,8.4 S75.1,129.9,71,129.9z M56.9,213.5c0,4.6-3.3,8.4-7.4,8.4s-7.4-3.8-7.4-8.4s3.3-8.4,7.4-8.4S56.9,208.8,56.9,213.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/LogoSmall.179c7596112dec0b22406c30ab6e5028.svg";
export { ForwardRef as ReactComponent };